import React, { useEffect } from "react";
import { motion } from "framer-motion";
import colors from "../styles/colors";
import { useTranslation } from "react-i18next";
import config from "../utils/config";

const LegalNotice: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col items-center font-serif"
      style={{ backgroundColor: colors.darkBrown, color: colors.lightCream }}
    >
      {/* Cím külön div-ben, hogy mindig felül legyen */}
      <motion.div
        className="w-full h-[50vh] flex flex-col justify-center items-center text-center px-4"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ backgroundColor: colors.darkBrown }}
      >
        <h1
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl p-4"
          style={{ color: colors.lightCream }}
        >
          {t("legal_notice.title")}
        </h1>
      </motion.div>

      {/* Tartalom (logó + szöveg) */}
      <div className="w-full max-w-6xl flex flex-col-reverse lg:flex-row items-center justify-between p-8 md:p-12">
        {/* Bal oldal: Cég adatok */}
        <div className="w-full lg:w-2/3 flex flex-col text-center lg:text-left">
          <div className="text-lg sm:text-xl space-y-6">
            <h2
              className="text-2xl font-semibold"
              style={{ color: colors.primaryGreen }}
            >
              {t("legal_notice.company_info")}
            </h2>
            <div className="space-y-2">
              <p>
                <strong>{t("legal_notice.company_name")}:</strong>{" "}
                {config.legal_name}
              </p>
              <p>
                <strong>{t("legal_notice.address")}:</strong> {config.address}
              </p>
              <p>
                <strong>{t("legal_notice.phone")}:</strong> {config.phone}
              </p>
              <p>
                <strong>{t("legal_notice.email")}:</strong> {config.email}
              </p>
            </div>

            {/* Regisztrációs információk */}
            <h2
              className="text-2xl font-semibold mt-6"
              style={{ color: colors.primaryGreen }}
            >
              {t("legal_notice.registration_info")}
            </h2>
            <div className="space-y-2">
              <p>
                <strong>{t("legal_notice.cui")}:</strong> {config.cui}
              </p>
              <p>
                <strong>{t("legal_notice.j_number")}:</strong> {config.j_number}
              </p>
            </div>
          </div>
        </div>

        {/* Jobb oldal: Logo */}
        <div className="w-full lg:w-1/3 flex flex-col items-center justify-center mb-8 lg:mb-0">
          <img
            src="/assets/images/logo/uniart-1080-full-light.png"
            alt="Company Logo"
            className="max-w-[180px] sm:max-w-[220px] md:max-w-[250px] lg:max-w-[300px] h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
